module.exports = __webpack_public_path__ + "static/media/CTLI_11-235w.01a09102.webp";